const doc = [({"en":({"js":({"feedback_steps":({"edit":({"question_asked":"The question asked", "answer_given":"The answer given", "no_answer":"Intet svar"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;